import { render, staticRenderFns } from "./AreaCliente.vue?vue&type=template&id=5bc1dd2a&scoped=true"
import script from "./AreaCliente.vue?vue&type=script&lang=js"
export * from "./AreaCliente.vue?vue&type=script&lang=js"
import style0 from "./AreaCliente.vue?vue&type=style&index=0&id=5bc1dd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1dd2a",
  null
  
)

export default component.exports